/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ContractType:  * `light` - Light contract type.  * `standard` - Standard contract type.  * `unlimited` - Unlimited contract type. 
 */
export enum ContractTypeEnumDTO {
    LIGHT = 'light',
    STANDARD = 'standard',
    UNLIMITED = 'unlimited'
}

export class ClsContractTypeEnumDTO {
    LIGHT = 'light';
    STANDARD = 'standard';
    UNLIMITED = 'unlimited';
}

